import { useMemo } from 'react';
import type {
  ReactElement,
  ReactNode,
} from 'react';

import {
  Input,
  StyledInputButton,
} from '../Input';
import type {
  RenderInputButton,
} from '../Input';
import { ModalSelectButton } from '../ModalSelectButton';
import type {
  ModalSelectButtonModalRenderProps,
} from '../ModalSelectButton';

export type ModalSelectProps<ValueType> = {
  /**
   * Выключено ли поле
   */
  disabled?: boolean;
  /**
   * Есть ли у поля ошибка
   */
  hasError?: boolean;
  /**
   * Есть ли у поля предупреждение
   */
  hasWarning?: boolean;
  placeholder?: string;

  /**
   * Обработчик изменения значения поля
   */
  onChange?: (nextValue: ValueType) => void;

  /**
  * Функция рендера содержимого модального окна
   */
  renderModal: (renderProps: ModalSelectButtonModalRenderProps<ValueType>) => ReactNode;

  /**
   * Текст, выводящийся в поле
   */
  text: string;
};

export function ModalSelect<ValueType>({
  disabled = false,
  hasError = false,
  hasWarning = false,
  onChange = undefined,
  placeholder = '',
  renderModal,
  text,
}: ModalSelectProps<ValueType>): ReactElement {
  const buttons = useMemo<RenderInputButton<'input'>[]>(() => {
    const renderModalSelectButton: RenderInputButton<'input'> = ({
      small,
    }) => (
      <StyledInputButton
        as={ModalSelectButton}
        renderModal={renderModal}
        disabled={disabled}
        $small={small}
        onSelectFromModal={onChange as (nextValue: unknown) => void}
        key="select"
      />
    );

    return [renderModalSelectButton];
  }, [
    renderModal,
    disabled,
    onChange,
  ]);

  return (
    <Input
      disabled={disabled}
      hasError={hasError}
      hasWarning={hasWarning}
      readOnly
      value={text}
      placeholder={placeholder}
      rightButtons={buttons}
    />
  );
}
